import styled from "@emotion/styled";

export const BannerContainer = styled.div`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: ${({ $isLarge }) => ($isLarge ? "row" : "column")};
  align-items: ${({ $isLarge }) => ($isLarge ? "stretch" : "center")};
  gap: ${({ $isLarge }) => ($isLarge ? "16px" : "40px")};
  padding: 20px;
  border-radius: 8px;
  position: relative;
  max-height: 70vh;
  overflow-y: scroll;

  p {
    margin: 0;
    width: 100%;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  @media (max-width: 1100px) {
    width: 100%;
  }
`;

export const BannerImage = styled("img")`
  width: ${({ $isLarge }) => ($isLarge ? "100%" : "auto")};
  max-width: 100%;
  height: ${({ $isLarge }) => ($isLarge ? "100%" : "270px")};
  max-height: ${({ $isLarge }) => ($isLarge ? "100%" : "270px")};
  border-radius: 8px;
  object-fit: contain;
`;

export const CarouselControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 20px;
  width: min-content;
  min-width: 300px;
  box-sizing: border-box;
  position: absolute;
  bottom: -80px;
  left: 50%;
  transform: translateX(-50%);
`;

export const Dot = styled.button`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  background-color: ${({ $isActive, theme }) =>
    $isActive
      ? theme?.cores?.surfaceActionActivePrimary
      : theme?.cores?.textActionPrimary};
  transition: all 0.3s ease;
  padding: 0;
  margin: 0;

  &:hover {
    background-color: ${({ theme }) => theme?.cores?.textActionPrimary};
    transform: scale(1.2);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const ArrowButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme?.cores?.surfaceActionActivePrimary};
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  color: ${({ theme }) => theme?.cores?.textActionPrimary};
  transition: all 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme?.cores?.surfaceActionHoverPrimary};
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    font-size: 20px;
  }
`;
